"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentStateLabel = void 0;
__exportStar(require("./api/storm"), exports);
var AssessmentStateLabel;
(function (AssessmentStateLabel) {
    AssessmentStateLabel["CANCELLED"] = "Cancelled";
    AssessmentStateLabel["UNASSIGNED"] = "Unassigned";
    AssessmentStateLabel["IN_REVIEW"] = "In Review";
    AssessmentStateLabel["ASSIGNED"] = "Assigned";
    AssessmentStateLabel["ASSESSOR_COMPLETE"] = "Assessor Complete";
    AssessmentStateLabel["IN_PROGRESS"] = "In Progress";
    AssessmentStateLabel["STORM_CENTER_VERIFIED"] = "Storm Center Verified";
    AssessmentStateLabel["ACTION_REQUIRED"] = "Action Required";
})(AssessmentStateLabel = exports.AssessmentStateLabel || (exports.AssessmentStateLabel = {}));
//# sourceMappingURL=storm.js.map